import { strictObjectAccess } from '@ackee/redux-utils';

export const documentType = strictObjectAccess({
    INVOICE: 'invoice',
    BILL: 'bill',
    DEPOSIT: 'deposit',
    OTHER: 'other',
});
